
<div class="row background-color-wt">
  <div class="col-print-12 padding-left-0px">
    <div class="card background-color-wt">
      <div class="card-header padding-left-0px border-bottom-0 padding-top-0px padding-bottom-0px"></div>
      <div class="card-body padding-top-0px padding-bottom-0px font-weight-normal">

        <div class="row">
          <div class="col-print-12 text-align-center border-bot-1px">
            <label class="margin-bottom-5px font-familyhead">Material Tracking</label>
          </div>
        </div>

        <!--<div class="col-print-12">
    <div class="row bordertop margin-right-0px">
      <div class="col-print-6"></div>
      <div class="col-print-6 text-align-end">
        <label class="margin-bottom-0px font-family font-weight-normal" *ngIf="SelectedFromDate">Date: {{SelectedDateNew| date:'MMM-dd-yyyy'}}</label>
      </div>
    </div>
  </div>-->


        <div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family font-weight-normal font-familysubhead">Material Name: {{Description}}</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family font-weight-normal float-right">From Date: {{FSelectedDay}}-{{FSelectedMonth}}-{{FSelectedYear}}</label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family18px font-weight-normal">Group Name: {{GroupName}}</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-right font-weight-normal">To Date: {{TSelectedDay}}-{{TSelectedMonth}}-{{TSelectedYear}}</label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family font-weight-bold font-familysubhead">Batches</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-right-0px margin-left-0px">
            <div class="col-print-12">
              <div class="table-component margin-bottom-0px">
                <div class="table-responsive">
                  <table class="table table-striped margin-left-zero border4">
                    <thead>
                      <tr>

                        <th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          Entry Date
                        </th>
                        <th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          HsnCode
                        </th>
                        <th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          Supplier
                        </th>
                        <th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          Batch
                        </th>
                        <th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          Expiry Date
                        </th>
                        <th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          Tax(%)
                        </th>
                        <th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          Batch qty
                        </th>
                        <th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          Avl.qty
                        </th>

                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let l of CurrentMaterialBatchInaStoreController ; let RowIndex = index ">

                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">
                          {{l.EntryDate | date:'MMM-dd-yyyy'}}
                        </td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-right">
                          {{l.HsnCode}}
                        </td>

                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">
                          {{l.SupplierShortName}}
                        </td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-right">
                          {{l.BatchNo}}
                        </td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">
                          {{l.ExpiryDate | date:'MMM-dd-yyyy'}}
                        </td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-right">
                          {{l.TaxPercent}}
                        </td>

                        <td class="font-family padding-top-2px padding-bottom-2px text-align-right">
                          {{l.BatchQuantity}}
                        </td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-right">
                          {{l.AvailableQuantity}}
                        </td>
                      </tr>
                    </tbody>
                  </table>

                </div>
              </div>
            </div>
          </div>
        </div>

        <!--<div class="col-print-12">
    <div class="row margin-left-0px">
      <div class="col-print-6">
        <label class="margin-bottom-0px font-family font-weight-bold font-familysubhead"></label>
      </div>
      <div class="col-print-6">
        <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
      </div>
    </div>
  </div>-->

        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family font-weight-bold font-familysubhead">Sales</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>

        <div class="col-print-12">
          <div class="row margin-right-0px margin-left-0px">
            <div class="col-print-12">
              <div class="table-component margin-bottom-0px">
                <div class="table-responsive">
                  <table class="table table-striped margin-left-zero border4">
                    <thead>
                      <tr>

                        <th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          Date
                        </th>
                        <th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          Patient
                        </th>
                        <th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          Quantity
                        </th>
                        <th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          Price
                        </th>
                        <th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          Item Total
                        </th>
                        <th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          Discount
                        </th>
                        <th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          Before Tax
                        </th>
                        <th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          Tax
                        </th>
                        <th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          Net
                        </th>

                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let l of CurrentItemWiseSalesController ; let RowIndex = index ">

                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">
                          {{l.BillDate | date:'MMM-dd-yyyy'}}
                        </td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">
                          {{l.PatientName}}
                        </td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-right">
                          <label class="margin-bottom-0px text-align-right">{{l.Quantity}}</label>
                        </td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-right">
                          {{l.UnitPrice}}
                        </td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-right">
                          {{(l.Quantity * l.UnitPrice)| number:'1.2-2'}}
                        </td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-right">
                          {{l.Discount| number:'1.2-2'}}
                        </td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-right">
                          {{l.AfterDiscount| number:'1.2-2'}}
                        </td>

                        <td class="font-family padding-top-2px padding-bottom-2px text-align-right">
                          {{l.TaxAmount| number:'1.2-2'}}
                        </td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-right">
                          {{l.Total| number:'1.2-2'}}
                        </td>
                      </tr>
                    </tbody>
                  </table>

                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family font-weight-bold font-familysubhead">Returns</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>

        <div class="col-print-12">
          <div class="row margin-right-0px margin-left-0px">
            <div class="col-print-12">
              <div class="table-component margin-bottom-0px">
                <div class="table-responsive">
                  <table class="table table-striped margin-left-zero border4">
                    <thead>
                      <tr>

                        <th class="font-weight-normal width-120px background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          Date
                        </th>
                        <th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          Material
                        </th>
                        <th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          Supplier
                        </th>
                        <th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          Batch
                        </th>
                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                          Return qty
                        </th>
                        <th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          Reason
                        </th>
                        <th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          Remarks
                        </th>
                        <th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          User
                        </th>

                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let l of CurrentPurchaseReturnsController ; let RowIndex = index ">

                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">
                          {{l.ReturnDate | date:'dd-MM-yyyy'}}
                        </td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">
                          {{l.Description}}
                        </td>

                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">
                          {{l.VendorName}}
                        </td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-right">
                          {{l.BatchNo}}
                        </td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">
                          {{l.ReturnQuantity}}
                        </td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">
                          {{l.Reason}}
                        </td>

                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">
                          {{l.Remarks}}
                        </td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">
                          {{l.UserName}}
                        </td>
                      </tr>
                    </tbody>
                  </table>

                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
<!--<printfooterview></printfooterview>-->
